import * as React from "react";

const LinkSaveOrderInactive: React.FC = () => (
    <svg
        width="12px"
        height="12px"
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="currentColor"
            d="M6.5625,0.5625 L6.5625,0 L5.4375,0 L5.4375,0.5625 L5.4375,6.89296889 L3.2109375,4.66640639 L2.8125,4.26796889 L2.01796854,5.0625 L2.41640604,5.4609375 L5.60156214,8.6484375 L5.99999964,9.046875 L6.39843714,8.6484375 L9.58593714,5.4609375 L9.98437464,5.0625 L9.18749964,4.26796889 L8.78906214,4.66640639 L6.56249964,6.89296889 L6.56249964,0.5625 L6.5625,0.5625 Z M3.01874971,7.125 L1.12499964,7.125 L-3.57598765e-07,7.125 L-3.57598765e-07,8.25 L-3.57598765e-07,10.875 L-3.57598765e-07,12 L1.12499964,12 L10.8749996,12 L11.9999996,12 L11.9999996,10.875 L11.9999996,8.25 L11.9999996,7.125 L10.8749996,7.125 L8.98124993,7.125 L7.85624993,8.25 L10.8749996,8.25 L10.8749996,10.875 L1.12499964,10.875 L1.12499964,8.25 L4.14374971,8.25 L3.01874971,7.125 Z M10.125,9.5625 C10.125,9.25184011 9.87315989,9 9.5625,9 C9.25184011,9 9,9.25184011 9,9.5625 C9,9.87315989 9.25184011,10.125 9.5625,10.125 C9.87315989,10.125 10.125,9.87315989 10.125,9.5625 Z"
            opacity=".5"
        />
    </svg>
);

export default React.memo(LinkSaveOrderInactive);
